import { Helmet } from 'react-helmet-async';
import { Suspense, useState } from 'react';
import { Card, Modal } from 'components';
import BankIDModal from 'pages/Registration/Intro/BankIDModal';
import useBankIdInfo from 'pages/Registration/BankId/BankInfo/useBankIdInfo';
import { TwButton } from 'components/TwButton/TwButton';
import { useTranslation } from 'react-i18next';
import TopSection from 'pages/Registration/BankId/BankInfo/TopSection';
import OrderedList from 'pages/Registration/BankId/BankInfo/OrderedList';

function BankIdInfo() {
  const { t } = useTranslation();
  const [openedModal, setOpenedModal] = useState<boolean>(false);

  const { initBankId, handleSkip, isPending } = useBankIdInfo();

  const secondaryBtnColor = isPending ? 'muted' : 'primary';

  return (
    <Suspense>
      <div data-test="bank-id-info" className="flex flex-col">
        <Helmet>
          <title>{t('bank_id:html_title')}</title>
        </Helmet>

        <Card className="flex flex-col gap-6 items-center">
          <TopSection handleButtonClick={() => setOpenedModal(true)} />
          <OrderedList />
          <div className="flex w-full justify-center lg:justify-start flex-col lg:flex-row">
            <TwButton
              onClick={initBankId}
              data-test="continue"
              pending={isPending}
            >
              {t('bank_id:continue')}
            </TwButton>
          </div>
        </Card>

        <button
          type="button"
          className={`border border-${secondaryBtnColor} text-${secondaryBtnColor} mt-6 p-3 rounded-sm lg:w-full max-w-[420px] mx-6 lg:mx-0 uppercase mb-10`}
          data-test="skip"
          disabled={isPending}
          onClick={handleSkip}
        >
          {t('bank_id:missing_id')}
        </button>
      </div>
      {openedModal && (
        <Modal className="flex-col" onClose={() => setOpenedModal(false)}>
          <BankIDModal />
        </Modal>
      )}
    </Suspense>
  );
}

export default BankIdInfo;
